import { axiosAjax } from '@app/src/config/axios';
import { TypePublicationModel } from '@app/src/views/StepTwo/channelPublication/models/typePublication';
import { hydrateData } from './hydrators';
import { CATEGORIES, CATEGORY, CATEGORY_ALIAS } from '@app/src/config/categories';

export const typePublicationService = {
  async get(categoryId: number, operationId?: number, idOwnInput?: number): Promise<TypePublicationModel[]> {
    try {
      let response = null;
      const config = CATEGORIES[CATEGORY[categoryId]];
      switch (config && config.alias) {
        case CATEGORY_ALIAS.OPORTUNIDAD:
          response = await axiosAjax.get(
            process.env.API_PUBLICATION_OPPORTUNITY
              .replace(':categoryId', '' + categoryId)
              .replace(':operationId', '' + operationId)
              .replace(':sectionId', '' + idOwnInput)
            );
          break;
        case CATEGORY_ALIAS.INMUEBLE:
          response = await axiosAjax.get(
            process.env.API_PUBLICATION_PROPERTY
              .replace(':categoryId', '' + categoryId)
              .replace(':operationId', '' + operationId)
              .replace(':propertyId', '' + idOwnInput)
            );
          break;
        case CATEGORY_ALIAS.VEHICULO:
          response = await axiosAjax.get(
            process.env.API_PUBLICATION_VEHICLE
              .replace(':categoryId', '' + categoryId)
              .replace(':operationId', '' + operationId)
              .replace(':vehicleId', '' + idOwnInput)
            );
          break;
        case CATEGORY_ALIAS.EDUCACION:
          response = await axiosAjax.get(
            process.env.API_PUBLICATION_EDUCATION
              .replace(':categoryId', '' + categoryId)
              .replace(':operationId', '' + operationId)
            );
          break;
        default:
          response = await axiosAjax.get(
            process.env.API_PUBLICATION
              .replace(':categoryId', '' + categoryId)
            );
      }

      const { data } = response;

      if (data.error) {
        throw new Error();
      }
      return hydrateData(data.data);
    } catch(e) {
      throw new Error(e);
    }
  }
}
